import { tagFor } from '@genesislcap/foundation-ui';
import { html, ref } from '@microsoft/fast-element';
/**
 * @public
 */
export const template = (options) => {
    const providerTag = tagFor(options.provider);
    const routerTag = tagFor(options.router);
    return html `
    <${providerTag} data-test-id="login-provider" ${ref('provider')}>
      <${routerTag} :config=${(x) => x.config} data-test-id="login-router"></${routerTag}>
    </${providerTag}>
  `;
};
